// /pages/CheckInHeatmapPage.jsx
import React, { useState } from 'react';
import MapboxHeatmap from '../../components/mapboxHeatmap/MapboxHeatmap';
import GenericHelmet from '../../components/genericHelmet/GenericHelmet';
const CheckInHeatmapPage = () => {
  const [region, setRegion] = useState('west tennessee');
  const [city, setCity] = useState('');
  const [days, setDays] = useState(30);

  return (
    <>
      <GenericHelmet
        title="Checkin Heatmap | JOE GALAXY.NET"
        description="Log in to JOEGALAXY.NET to access your adventure profile, join group chats, and continue exploring our interactive, gamified social platform."
        image="https://res.cloudinary.com/joegalaxy/image/upload/q_auto/v1664565843/Images/JOEGALAXYDopeGalaxyLogooriginal_tecmer.png"
        url="https://www.joegalaxy.net/login"
        regionName="Worldwide"
      />
      <div className="container mt-4">
        <h2 className="mb-3 text-center">📍 Check-In Heatmap</h2>

        <div className="row mb-3">
          <div className="col-md-4">
            <label>Region</label>
            <input
              type="text"
              className="form-control"
              value={region}
              onChange={(e) => setRegion(e.target.value)}
              placeholder="e.g., west tennessee"
            />
          </div>
          <div className="col-md-4">
            <label>City (optional)</label>
            <input
              type="text"
              className="form-control"
              value={city}
              onChange={(e) => setCity(e.target.value)}
              placeholder="e.g., camden"
            />
          </div>
          <div className="col-md-4">
            <label>Days</label>
            <input
              type="number"
              className="form-control"
              value={days}
              onChange={(e) => setDays(parseInt(e.target.value))}
              min={1}
              max={365}
            />
          </div>
        </div>

        <MapboxHeatmap region={region} city={city} days={days} />
      </div>
    </>
  );
};

export default CheckInHeatmapPage;
